import { HttpService } from 'services/http';


export const getAllCardsApi = (queryParams) => HttpService.get('/v3/cards', queryParams);

export const getCardIdDetails = (cardId: number) => HttpService.get(`/v3/cards/${cardId}`);

export const updateCardIdDetails = (cardId: number, requestPayload) => HttpService.put(`/v3/cards/${cardId}`, requestPayload);

export const updateCardIdLimits = (cardId, requestPayload) => HttpService.put(`/v2/cards/${cardId}/limits`, requestPayload);

export const bulkCardOrderApiRequest = (requestPayload) => HttpService.post('/v2/cards/order-bo', requestPayload);

export const processOrderNewCardApiRequest = (requestPayload) => HttpService.post('/v3/cards/order', requestPayload);

export const linkCardId = (cardId: number, requestPayload) => HttpService.post(`/v2/cards/${cardId}/link`, requestPayload);

export const unlinkCardId = (cardId: number) => HttpService.post(`/v2/cards/${cardId}/unlink`, {});

export const fetchCardProducts = (requestPayload) => HttpService.get('/v2/cards/products', requestPayload);

export const processCardsOrderApi = (requestPayload, queryParams) => HttpService.post('/v2/cards/process-orders', requestPayload, queryParams);

export const getCardIdPin = (cardId: number) => HttpService.get(`/v2/cards/${cardId}/pin`);

export const unblockCardPinByCardToken = (requestPayload) => HttpService.post('/v2/cards/unblock-pin', requestPayload);

export const getCardIdImage = (cardId: number) => HttpService.get(`/v2/cards/${cardId}/image`);

export const getNotLinkedCardsApi = (queryParams) => HttpService.get('/v3/cards/not-linked', queryParams);

export const deleteCardId = (cardId: number) => HttpService.delete(`/v2/cards/${cardId}`);

export const getCardIdStatusHistory = (cardId: number, queryParams) => HttpService.get(`/v2/cards/${cardId}/status-history`, queryParams);
